<template>
	<SidePanel v-if="currentSidePanel" v-model="isPanelOpen" :title="currentSidePanel.title" :size="currentSidePanel.size" :fullscreen="currentSidePanel.fullscreen" :force-non-fullscreen="currentSidePanel.forceNonFullscreen" :show-close-button="currentSidePanel.showCloseButton ?? true" :hide-header="currentSidePanel.hideHeader" :close-on-backdrop-click="currentSidePanel.closeOnBackdropClick ?? true" :prevent-scroll="currentSidePanel.preventScroll ?? true" :header-style="currentSidePanel.headerStyle" :no-pad="currentSidePanel.noPad">
		<component :is="currentSidePanel.component" v-bind="currentSidePanel.props || {}" />
	</SidePanel>
</template>

<script lang="ts" setup>
import SidePanel from "./index.vue";
import { useSidePanelManager } from "../../composables/useSidePanelManager";

const { currentSidePanel, isSidePanelOpen, closeCurrentSidePanel } = useSidePanelManager();

const isPanelOpen = computed({
	get: () => isSidePanelOpen.value,
	set: (value) => {
		if (!value) {
			closeCurrentSidePanel();
		}
	},
});
</script>
